import { CmsApiRecommendedJobsBlockData } from 'modules/cms/api/types/blocks/CmsApiRecommendedJobsBlock';
import { useAmpContext } from 'utils/AmpContext';

import { CmsAmpRecommendedJobs } from './Amp';
import { CmsStandardRecommendedJobs } from './Standard';

type Props = {
  data: CmsApiRecommendedJobsBlockData;
  source: 'RECOMMENDED_JOBS_CHECKBOX' | 'RECOMMENDED_JOBS_BLOCK';
};

export function CmsRecommendedJobsBlockContent({
  data: { headline, layout, jobFunction, areaOfFocus },
  source,
}: Props) {
  const isAmp = useAmpContext();

  if (isAmp) {
    return (
      <CmsAmpRecommendedJobs
        headline={headline}
        layout={layout}
        jobFunction={jobFunction}
        areaOfFocus={areaOfFocus}
        source={source}
      />
    );
  }

  return (
    <CmsStandardRecommendedJobs
      headline={headline}
      layout={layout}
      jobFunction={jobFunction}
      areaOfFocus={areaOfFocus}
      source={source}
    />
  );
}
